import { Button } from './Button';
import { ButtonsGroup } from './ButtonsGroup';

interface ButtonsGroupSingleSelectProps {
    variant: 'black' | 'outlined';
    disabled?: boolean;
    options: {
        value: string;
        label: string;
    }[];
    onSelect: (id: string) => void;
}

export const ButtonsGroupSingleSelect = ({ variant, disabled, options, onSelect }: ButtonsGroupSingleSelectProps) => {
    return (
        <ButtonsGroup animated={false}>
            {options.map((option) => (
                <Button key={option.value} label={option.label} onClick={() => onSelect(option.value)} variant={variant} inactive={disabled} />
            ))}
        </ButtonsGroup>
    );
};